<div *ngIf="!appLocaleService.addInProgress" class="message-header full-width row scroll-visible">
    <div
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <li class="list-item">
                <div class="item">
                    <label class="app-label title">{{locale.LABEL_APP_MESSAGE_KEY}}</label>
                    <button name="wm-add-new-message" class="float-right btn button-primary btn-sm add-message-btn"
                        [disabled]="appLocaleService.addInProgress || selectedPrefab" (click)="showNewField();"
                        *wmsFeature="preferences.project.i18n.edit">
                        <i class="wm-icon wms wms-plus"
                            title="{{locale.LABEL_ADD + ' ' +locale.LABEL_APP_MESSAGE_KEY}}"></i>
                    </button>
                </div>
            </li>
        </ul>
    </div>
    <div
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <li class="list-item" [ngClass]="{'last-item': !appLocaleService.multipleLocaleExists}">
                <div class="item">
                    <label class="app-label title">{{locale.LABEL_LANG_ENGLISH}}</label>
                </div>
            </li>
        </ul>
    </div>
    <div *ngIf="appLocaleService.multipleLocaleExists"
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <li class="list-item last-item select-container">
                <div class="item">
                    <select class="form-control app-select" name="wm-locale-select" (change)="tempLocaleChanged()"
                        [(ngModel)]="appLocaleService.selectedTempLocale.key">
                        <option *ngFor="let map of appLocaleService.supportedLocaleCodesMap | keyvalue"
                            [value]="map.key">{{map.value}}
                        </option>
                    </select>
                </div>
            </li>
        </ul>
    </div>
</div>
<div *ngIf="appLocaleService.addInProgress" class="input-container full-height row scroll-visible"
    [ngClass]="{'add-progress': appLocaleService.addInProgress}">
    <div class="col-xs-12 message-header">
        <div class="col-xs-12 message-box">
            <label class="app-label control-label col-xs-4">{{locale.LABEL_HEADER_I18N_ADD_MESSAGE_KEY}}</label>
            <div class="col-xs-8">
                <input class="form-control app-textbox" [(ngModel)]="appLocaleService.newMessage.key"
                    [ngModelOptions]="{'updateOn': 'change'}">
            </div>
        </div>
    </div>
    <div class="col-xs-12 new-messages-container">
        <div class="col-xs-12 message-box">
            <label class="app-label control-label col-xs-4">{{locale.LABEL_LANG_ENGLISH}}</label>
            <div class="col-xs-8">
                <input class="form-control app-textbox" [(ngModel)]="appLocaleService.newMessage.en"
                    [ngModelOptions]="{'updateOn': 'change'}">
            </div>
        </div>
        <div class="col-xs-12 message-box" *ngFor="let map of appLocaleService.supportedLocaleCodesMap | keyvalue">
            <label class="app-label control-label col-xs-4">{{map.value}}</label>
            <div class="col-xs-8">
                <input class="form-control app-textbox" [(ngModel)]="appLocaleService.newMessage[$any(map.key)]"
                    [ngModelOptions]="{'updateOn': 'change'}">
            </div>
        </div>
    </div>
</div>
<!-- render the messages(keys & values) at once after they are constructed -->
<div class="message-table" *ngIf="!appLocaleService.addInProgress && appLocaleService.validationMessage?.caption !== locale.PREPARING_MESSAGES">
    <div
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <!-- | filter:ctrlScope.messageFilter -->
            <!-- preferences['project.i18n.edit'] && -->
            <li (click)="edit($event, message)" class="list-item" title="{{message}}"
                *ngFor="let message of (selectedPrefab ? filteredPrefabMessagesList : filteredMessagesList)"
                [ngClass]="{'marked-deleted': appLocaleService.isMessageDeleted(message), 'active': appLocaleService.activeMessage.en && appLocaleService.activeMessage.en[message]}">
                <div class="item">
                    <div class="title">{{message}}</div>
                    <i class="wm-icon wms hover-fix pull-right"
                        title="{{locale.MESSAGE_APP_MESSAGES_DIALOG_DELETE_MESSAGE}}"
                        [ngClass]="appLocaleService.isMessageDeleted(message) ? 'wms-undo' : 'wms-delete'"
                        *ngIf="!appLocaleService.systemMessageKeys[message] && !selectedPrefab"
                        (click)="toggleDelete($event, message)"></i>
                    <i class="wm-icon wms hover-fix pull-right wms-lock"
                        title="{{locale.MESSAGE_APP_MESSAGES_DIALOG_SYSTEM_MESSAGE}}"
                        *ngIf="appLocaleService.systemMessageKeys[message] && !selectedPrefab"></i>
                    <i class="wm-icon wms hover-fix pull-right wms-lock"
                        title="{{locale.MESSAGE_APP_MESSAGES_DIALOG_PREFAB_MESSAGE}}"
                        *ngIf="selectedPrefab"></i>
                </div>
            </li>
        </ul>
    </div>
    <div
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <!-- | filter:ctrlScope.messageFilter -->
            <!-- preferences['project.i18n.edit'] && -->
            <li (click)="edit($event, message)" class="list-item" title="{{selectedPrefab ? appLocaleService.userPrefabMessages.en[selectedPrefab]?.[message] : appLocaleService.userMessages.en[message]}}"
                [ngClass]="{'compress': appLocaleService.activeMessage.en && appLocaleService.activeMessage.en[message], 'marked-deleted': appLocaleService.isMessageDeleted(message)}"
                *ngFor="let message of (selectedPrefab ? filteredPrefabMessagesList : filteredMessagesList)"
                [ngClass]="{'marked-deleted': appLocaleService.isMessageDeleted(message)}">
                <div class="item">
                    <div *ngIf="!appLocaleService.activeMessage.en || !appLocaleService.activeMessage.en[message]"
                        class="title">
                        {{selectedPrefab ? appLocaleService.userPrefabMessages.en[selectedPrefab]?.[message] : appLocaleService.userMessages.en[message]}}
                    </div>
                    <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)"
                        *ngIf="appLocaleService.activeMessage.en?.[message] && !selectedPrefab"
                        [(ngModel)]="appLocaleService.userMessages.en[message]"
                        [ngModelOptions]="{'updateOn': 'change'}">
                    <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)"
                        *ngIf="appLocaleService.activeMessage.en?.[message] && selectedPrefab"
                        [ngModel]="appLocaleService.userPrefabMessages.en[selectedPrefab] && appLocaleService.userPrefabMessages.en[selectedPrefab][message]" (ngModelChange)="appLocaleService.userPrefabMessages.en[selectedPrefab] && (appLocaleService.userPrefabMessages.en[selectedPrefab][message] = $event)"
                        [ngModelOptions]="{'updateOn': 'change'}">
                    <button class="close pull-right"
                        *ngIf="appLocaleService.activeMessage.en && appLocaleService.activeMessage.en[message]"
                        (click)="edit($event);" title="{{locale.LABEL_CLOSE}}"><i
                            class="wm-icon wms wms-done"></i></button>
                </div>
            </li>
        </ul>
    </div>
    <div *ngIf="appLocaleService.multipleLocaleExists"
        [ngClass]="{'message-three-col-view': appLocaleService.multipleLocaleExists, 'message-two-col-view': !appLocaleService.multipleLocaleExists}">
        <ul class="list-items messages">
            <!-- | filter:ctrlScope.messageFilter -->
            <!-- preferences['project.i18n.edit'] && -->
            <li (click)="edit($event, message)" class="list-item"
                title="{{selectedPrefab ? appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab]?.[message] : appLocaleService.userMessages[appLocaleService.selectedTempLocale.key][message]}}"
                [ngClass]="{'compress': appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key] && appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key][message], 'marked-deleted': appLocaleService.isMessageDeleted(message)}"
                *ngFor="let message of (selectedPrefab ? filteredPrefabMessagesList : filteredMessagesList)"
                [ngClass]="{'marked-deleted': appLocaleService.isMessageDeleted(message)}">
                <div class="item">
                    <div *ngIf="!selectedPrefab">
                        <div *ngIf="(!appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key] || !appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key][message]) && appLocaleService.userMessages[appLocaleService.selectedTempLocale.key] && appLocaleService.userMessages[appLocaleService.selectedTempLocale.key][message]"
                        class="title">
                        {{appLocaleService.userMessages[appLocaleService.selectedTempLocale.key][message]}}
                    </div>
                    <div *ngIf="(!appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key] || !appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key][message]) && (!appLocaleService.userMessages[appLocaleService.selectedTempLocale.key] || !appLocaleService.userMessages[appLocaleService.selectedTempLocale.key][message])"
                        class="title">
                        &nbsp;
                    </div>
                    </div>
                    <div *ngIf="selectedPrefab">
                        <div *ngIf="!appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key]?.[message] && appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab]?.[message]"
                        class="title">
                        {{appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab]?.[message]}}
                    </div>
                    <div *ngIf="!appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key]?.[message] && !appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab]?.[message]"
                        class="title">
                        &nbsp;
                    </div>
                    </div>
                    <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)"
                        *ngIf="appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key] && appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key][message] && !selectedPrefab"
                        [(ngModel)]="appLocaleService.userMessages[appLocaleService.selectedTempLocale.key][message]"
                        [ngModelOptions]="{'updateOn': 'change'}">
                    <input class="form-control app-textbox" (click)="appLocaleService.onInputClick($event)"
                        *ngIf="appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key]?.[message] && selectedPrefab"
                        [ngModel]="appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab] && appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab][message]" (ngModelChange)="appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab] && (appLocaleService.userPrefabMessages[appLocaleService.selectedTempLocale.key][selectedPrefab][message] = $event)"
                        [ngModelOptions]="{'updateOn': 'change'}">
                    <button class="close pull-right"
                        *ngIf="appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key] && appLocaleService.activeMessage[appLocaleService.selectedTempLocale.key][message]"
                        (click)="edit($event);" title="{{locale.LABEL_CLOSE}}"><i
                            class="wm-icon wms wms-done"></i></button>
                </div>
            </li>
        </ul>
    </div>

<div *ngIf="appLocaleService.validationMessage?.caption !== locale.PREPARING_MESSAGES && selectedPrefab && !filteredPrefabMessagesList.length" class="empty-screen-msg">{{locale.LABEL_EMPTY_PREFAB_MESSAGES_SCREEN}}</div>
</div>
